import { useEffect } from 'react';
import * as oauth from '../oauth.js';

const TgOauthCallback = () => {
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const code = query.get('code');
    if (!code) return;

    oauth.TelegramLoginWidgetAuth({
      tgData: { code },
      onJWTObtained: () => {
        // Desktop: popup has opener, notify parent and close
        if (window.opener) {
          window.opener.location.href = '/';
          window.close();
          return;
        }
        // Mobile: no opener, just redirect in this tab
        window.location.href = '/';
      }
    }).catch((err) => {
      console.error('Telegram OAuth callback failed:', err);
      if (window.opener) {
        window.close();
      } else {
        window.location.href = '/';
      }
    });
  }, []);

  return null;
};

export default TgOauthCallback;
